import React from 'react';
import { CheckIcon } from 'lucide-react';
import { SectionTag } from './SectionTag';
import { CTAButton } from './CTAButton';
import { PriceBlock } from './PriceBlock';
import { OFFER_INCLUDES } from './salesData';
import { BUNDLE_IMAGE_URL } from '../utils/headMeta';
export function OfferSection() {
  return <section id="comprar" className="bg-sand py-14 sm:py-20" data-id="element-232" data-mp="def0n3rwzhwa">
      <div className="mx-auto max-w-6xl px-5" data-id="element-233" data-mp="id8dctzdn4ve">
        <div className="text-center" data-id="element-234" data-mp="icgffcib4v1y">
          <SectionTag className="bg-white" data-id="element-235" data-mp="ifkrew20kv36">El sistema completo</SectionTag>
          <h2 className="mx-auto mt-4 max-w-[20ch] font-display text-[1.6rem] font-extrabold leading-[1.15] tracking-tight text-charcoal sm:max-w-[30ch] sm:text-[2.4rem]" data-id="element-236" data-mp="md8q8a6tv80c">
            Todo lo que recibís en un <span className="text-gold" data-id="element-237" data-mp="wchi8xi4uck2">solo acceso</span>.
          </h2>
        </div>

        <div className="mt-10 overflow-hidden rounded-[2rem] border border-stone bg-white shadow-[0_40px_80px_-50px_rgba(56,37,34,0.6)]" data-id="element-238" data-mp="2t6kw62h2c0q6">
          <div className="grid lg:grid-cols-[minmax(0,1fr)_minmax(0,1fr)]" data-id="element-239" data-mp="2y67a6e4ptl01">
            <div className="flex items-center justify-center bg-cream p-6 sm:p-10" data-id="element-240" data-mp="12otenehhl7hf">
              <img src={BUNDLE_IMAGE_URL} alt="Mockup oficial del libro Postres que Venden™" loading="lazy" decoding="async" width={1254} height={1254} className="h-auto w-full max-w-[380px] object-contain drop-shadow-[0_26px_34px_rgba(56,37,34,0.22)]" data-id="element-241" data-mp="xw0d0zhbef9k" />
            </div>

            <div className="p-6 sm:p-9" data-id="element-242" data-mp="1gokwxrf1da18">
              <p className="font-display text-[1.5rem] font-extrabold uppercase leading-none tracking-tight text-charcoal sm:text-[1.9rem]" data-id="element-243" data-mp="1clod5xdrf7vp">
                Postres que Venden™
              </p>
              <p className="mt-2.5 font-sans text-[0.87rem] font-semibold text-taupe" data-id="element-244" data-mp="17oy0lk15yuf1">
                145 páginas + 60 recetas + Método M.V.P.™ + 12 boxes + 5 bonos
              </p>

              <ul className="mt-5 space-y-2 border-t border-stone pt-5" data-id="element-245" data-mp="3sex49hb6ehbu">
                {OFFER_INCLUDES.map(item => <li key={item} className="flex gap-2.5 font-sans text-[0.86rem] leading-snug text-charcoal/85" data-id="element-246" data-mp="2nooc51nczt6">
                    <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-gold" aria-hidden strokeWidth={3} data-id="element-247" data-mp="3kvdztm2rpla8" />
                    {item}
                  </li>)}
              </ul>

              <PriceBlock className="mt-7" size="lg" data-id="element-248" data-mp="3b26w05noedc9" />

              <div className="mt-5 flex justify-center" data-id="element-249" data-mp="3fuhxhcy2e76x">
                <CTAButton className="w-full max-w-[26rem] px-4" label="QUIERO POSTRES QUE VENDEN™" data-id="element-250" data-mp="3fw1h9dixj0dg" />
              </div>

              <p className="mt-3.5 text-center font-sans text-[0.76rem] font-semibold text-taupe" data-id="element-251" data-mp="3645evq9t8o3f">
                Compra única · Acceso digital inmediato
              </p>
              <p className="mt-1.5 text-center font-sans text-[0.72rem] text-taupe/80" data-id="element-252" data-mp="2s701t6boioyo">
                🔒 Pago seguro · Mercado Pago · Tarjetas de crédito
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}